import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    // Prevent reinitialization or don't initialize if we're not in an iframe
    if (window.self === window.top) {
      return
    }

    this.initFrame()
  }

  initFrame () {
    let variant = 'embed'
    const url = new URL(document.location)
    const modalSize = url.searchParams.get('modal')

    if (modalSize && modalSize !== 'true') {
      variant = modalSize
    }

    window.provenance.frameFactory.getFrame(variant, document.location.href)
  }
}
